<template>
  <a-layout>
    <a-card :bordered="false">
      <SmallSquare content='*二维码范围（提示：必须添加至少一个范围，所选范围不能重复或重叠）' :padding='false' class="m-b-20"></SmallSquare>
      <div class='mb10 s_flex_ali' v-if="$route.query.type!='detail'">
        <span class='mr15'>
          <a-button type="primary" @click="create">
            <PlusOutlined />
           添加提货码
          </a-button>
        </span>
      </div>
      <div class="s_c999 mb10"><span class="s_c333">总数:</span> （提示：必须添加至少一个范围，所选范围不能重复或重叠）</div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list' :scroll="{ x: 'max-content'}">
        <template v-slot:action="{ record }">
          <a-popconfirm title="确定要删除该批次么？" @confirm="del(record)" ok-text="删除" cancel-text="取消" placement="topRight" v-if="$route.query.type!='detail'" >
            <a-button type="danger" size="small" href="javascript:;">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
      <div  class="s_flex_center">
        <a-button @click="provide()" class="  m-t-20 m-r-20">上一步</a-button>
        <a-button type="primary" @click="next()" class="  m-t-20 ">下一步</a-button>
      </div>

    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" v-model:visible="visible" centered :width='1300' destroyOnClose :confirm-loading="confirmLoading">
        <selectPickUpCode v-on:select="selectList" :selectList='[{id:form.batch_sn}]' :id="id" v-on:done="createDone"> </selectPickUpCode>
  </a-modal>
</template>
<script>

import {getVoucherList,delVoucherBatchList} from '@/api/assets'
import { PlusOutlined } from "@ant-design/icons-vue";
import { onMounted, ref } from "vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
const labelCol = { span: 4 };
const wrapperCol = { span: 18 };
const def = {
  voucher_id: "", //
  batch_sn:"",
  small_serial_start: "", //开启流水号
  small_serial_end: "", //结束流水号
};
let columns = [
  {
    title: "批次",
    dataIndex: "batch_sn",
    key: "batch_sn",
  },
  {
    title: "起始流水号",
    dataIndex: "small_serial_start",
    key: "small_serial_start",
  },
  {
    title: "结束流水号",
    key: "small_serial_end",
    dataIndex: "small_serial_end",
  },
  {
    title: "区间数量",
    dataIndex: "small_code_counts",
    key: "small_code_counts",
  },
  {
    title: "操作",
    key: "action",
    width: 150,
    slots: { customRender: "action" },
  },
];
const rules = {
  small_serial_start: [
    {
      required: true,
      message: "请输入起始流水号",
    },
  ],
  small_serial_end: [
    {
      required: true,
      message: "请输入结束流水号",
    },
  ],
};
export default {
  components: { PlusOutlined },
  props: {
    id: {
      type:  Number || String,
      default: () => {
        return null;
      },
    },
  },
  setup(props, { emit }) {
    const form = ref(JSON.parse(JSON.stringify(def)));
    const ruleForm = ref();
    const listLoading = ref(true);
    const list = ref([]);
    const visible = ref(false);
    const confirmLoading = ref(false)
    const create=()=>{
      visible.value=true;
      form.value={
          add_mode: 1, //暂时只有1
          batch_sn: [],
          is_serial: false, //是否设置起始流水号
          small_serial_start: "", //开启流水号
          small_serial_end: "", //结束流水号
      };
    }
    // 获取详情
    const detail = async () => {
      listLoading.value = true;
      let result = await getVoucherList({voucher_id:props.id})
        .then((res) => res.data)
        .catch((error) => error);
      listLoading.value = false;
      if (iscode(result)) {
        list.value = result.data.data;
      } else {
        message.error(result.message);
      }
    };
    // 下一步
    const next = () => {
      emit("setpsTwoNext", 1);
    };
    const provide = () => {
      emit("setpsTwoProvide", 1);
    };
    // 删除
    const del = async (data) => {
      let result = await delVoucherBatchList({id:data.id})
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        detail();
      }
    };

    // 用于记录 选中的批次 数据
    const batch = ref({});
    const batchChange = (data) => {
      batch.value = data[0];
      form.value.batch_sn = data.map(v=>v.batch_sn);
      console.log( form.value.batch_sn)
    };

    onMounted(() => {
      detail();
    });
    const createDone=()=>{
        visible.value = false;
      detail()
    }
    return {
      create,
      columns,
      listLoading,
      list,
      form,
      rules,
      ruleForm,
      labelCol,
      wrapperCol,
      del,
      detail,
      next,
      provide,
      visible,
      batch,
      batchChange,
      def,
      confirmLoading,
      createDone
    };
  },
};
</script>